import { Button } from 'react-daisyui';
import type { SettingRow } from '@/hooks/useSettings';

interface ConfigListRowProps {
  row: SettingRow;
  onEdit: (row: SettingRow) => void;
}

// One list row with its entries. A row whose editable column is false has no Edit button. A value
// that is not a list (any other JSON) is shown as stored.
export default function ConfigListRow({ row, onEdit }: ConfigListRowProps) {
  let shownValue: string;
  if (Array.isArray(row.value)) {
    shownValue = row.value.length ? row.value.map(String).join(', ') : 'Empty';
  } else {
    shownValue = JSON.stringify(row.value);
  }

  return (
    <li
      className='flex flex-col md:flex-row md:items-start gap-2 md:gap-6 py-3 border-b border-base-300 last:border-b-0'
      data-testid={`setting-row-${row.key}`}
    >
      <div className='flex-1 min-w-0'>
        <h3 className='font-semibold'>{row.label}</h3>
        {row.description && (
          <p className='text-sm text-gray-400'>{row.description}</p>
        )}
        <p className='text-xs mt-1'>
          <code className='font-mono text-gray-300'>{row.key}</code>
        </p>
        <p className='text-sm mt-1 break-words'>{shownValue}</p>
      </div>
      <div className='md:w-64 shrink-0 text-right'>
        {row.editable && row.valueType !== null && (
          <Button
            type='button'
            size='xs'
            color='accent'
            variant='outline'
            aria-label={`Edit ${row.label}`}
            onClick={() => onEdit(row)}
          >
            Edit
          </Button>
        )}
      </div>
    </li>
  );
}
